/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { Table, Button, message } from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import Modal from './modal'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      userInfo: {},
      action: '-1',
    }
  }

  componentDidMount() {
    if (!this.props.regionList) this.props.fetchRegionList()
    this.props.fetchRoleList()
  }

  //action1为修改 -1为增加
  onShowModal = (record) => {
    this.setState({ visible: true, userInfo: record, action: '1' })
  }

  handleOk = () => {
    const { userInfo, action } = this.state
    if (
      action === '-1' &&
      sessionStorage.getItem('belongto') &&
      sessionStorage.getItem('phone') &&
      sessionStorage.getItem('role_id')
    ) {
      //新增
      let data = {
        // account: sessionStorage.getItem('account'),
        // password: sessionStorage.getItem('password'),
        belongto: sessionStorage.getItem('belongto'),
        phone: sessionStorage.getItem('phone'),
        role_id: sessionStorage.getItem('role_id'),
        region: sessionStorage.getItem('region_id'),
      }
      this.props.fetchAddAccount(data)
      this.setState({ visible: false, userInfo: {} }, () => this.clearSession())
    } else if (action === '1') {
      //修改
      let data = {
        account_id: userInfo.id,
        // account: sessionStorage.getItem('account') || userInfo.account,
        // password: sessionStorage.getItem('password') || "",
        belongto: sessionStorage.getItem('belongto') || userInfo.belongto,
        phone: sessionStorage.getItem('phone') || userInfo.phone,
        role_id: sessionStorage.getItem('role_id') || userInfo.role_id,
        region: sessionStorage.getItem('region_id') || userInfo.region_id,
      }
      this.props.fetchEditAccount(data)
      this.setState({ visible: false, userInfo: {} }, () => this.clearSession())
    } else {
      message.info('请请填写完整信息')
    }
  }

  clearSession = () => {
    sessionStorage.removeItem('belongto')
    sessionStorage.removeItem('phone')
    sessionStorage.removeItem('role_id')
  }

  handleCancel = () => {
    this.setState({ visible: false, userInfo: {} }, () => this.clearSession())
  }

  render() {
    const { list, roleList, regionList } = this.props
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '管理员名称',
        dataIndex: 'belongto',
        key: 'belongto',
      },
      {
        title: '电话',
        dataIndex: 'phone',
        key: 'phone',
      },
      {
        title: '登录时间',
        dataIndex: 'final_login_time',
        key: 'final_login_time',
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <div style={{ color: '#108EE9', cursor: 'default' }}>
              <Button
                type="primary"
                style={{ marginRight: '20px' }}
                onClick={() => this.onShowModal(record)}
              >
                修改
              </Button>
              <Popconfirm
                title={`你确认要删除${record.belongto}管理员吗?`}
                okText="确认"
                cancelText="取消"
                onConfirm={() => this.props.fetchDelAccount(record.id)}
              >
                <Button type="primary" danger>
                  删除
                </Button>
              </Popconfirm>
            </div>
          )
        },
      },
    ]

    return (
      <div>
        <div
          style={{
            marginBottom: '20px',
          }}
        >
          <Button
            type="primary"
            onClick={() => this.setState({ visible: true, action: '-1' })}
          >
            添加管理员
          </Button>
        </div>
        <Table rowKey="id" bordered columns={columns} dataSource={list} />
        {this.state.visible && (
          <Modal
            {...this.state}
            roleList={roleList}
            regionList={regionList}
            handleOk={this.handleOk}
            handleCancel={this.handleCancel}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubUsers/component/users.js